module.exports = __webpack_public_path__ + "static/media/mob_alert_partner_gold_x1.c68afa40.png";